import { useQuery } from "react-query";
import { searchMusicArchives, getMusicArchiveById } from "frontend/src/api/music-archives";
import { useUpdateMusicArchive } from ".";
import { useClientIdEdit } from "../tracks";
import { cacheKey } from "./shared";
export var useSearchMusicArchives = function (params) {
    var _a = useQuery([cacheKey, params], function () {
        return searchMusicArchives(params);
    }), data = _a.data, isLoading = _a.isLoading;
    return { data: data, isLoading: isLoading };
};
export var useMusicArchiveEdit = function (musicArchive) {
    var update = useUpdateMusicArchive();
    var client_id = useClientIdEdit(musicArchive.client_id);
    var run = function () {
        update.do({
            musicArchiveId: musicArchive.id,
            clientId: client_id.value,
        });
    };
    return {
        client_id: client_id,
        update: {
            run: run,
            pending: update.isLoading
        }
    };
};
export var useMusicArchiveDetail = function (id) {
    var _a = useQuery([cacheKey, id], function () {
        return getMusicArchiveById(id);
    }), data = _a.data, isFetching = _a.isFetching, isLoading = _a.isLoading, remove = _a.remove;
    return { track: data, isFetching: isFetching, isLoading: isLoading, remove: remove };
};
